import { Component } from '@angular/core';
import { AuditDto } from '@models/authorizations/audit.dto';
import { AccountService } from '@services/account.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-access-history-dialog',
  templateUrl: './access-history-dialog.component.html',
  styleUrls: ['./access-history-dialog.component.scss'],
})
export class AccessHistoryDialogComponent {
  readonly pageSize = 5;
  readonly historySize = 100;
  search = '';
  page = 0;
  loading = true;
  accesses: AuditDto[] = [];

  get userId(): number {
    return this.config.data.sign.signId;
  }

  get userName(): string {
    const subscriber = this.config.data.sign.subscriber;
    return subscriber
      ? `${subscriber.name || ''} ${subscriber.lastName || ''}`.trim()
      : this.config.data.sign.email || '';
  }

  get filteredAccesses(): AuditDto[] {
    const term = this.search.trim().toLowerCase();
    if (!term) return this.accesses;
    return this.accesses.filter((access) =>
      [access.responseRawHeaders, access.category, access.path,
       access.method, access.status, access.statusMessage,
       access.errors, access.firingDate]
        .some((value) => String(value ?? '').toLowerCase().includes(term)),
    );
  }

  get total(): number {
    return this.filteredAccesses.length;
  }

  get pageCount(): number {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  get pageAccesses(): AuditDto[] {
    return this.filteredAccesses.slice(
      this.page * this.pageSize,
      (this.page + 1) * this.pageSize,
    );
  }

  get firstItem(): number {
    return this.total ? this.page * this.pageSize + 1 : 0;
  }

  get lastItem(): number {
    return Math.min((this.page + 1) * this.pageSize, this.total);
  }

  constructor(
    private accountService: AccountService,
    private config: DynamicDialogConfig,
  ) {
    this.loadAccesses();
  }

  onSearchChange(): void {
    this.page = 0;
  }

  previousPage(): void {
    if (this.page > 0) this.page--;
  }

  nextPage(): void {
    if (this.page < this.pageCount - 1) this.page++;
  }

  loadAccesses(): void {
    this.loading = true;
    this.accountService.getUserHistory(this.userId, this.historySize).subscribe({
      next: (result) => {
        this.accesses = result || [];
        this.page = 0;
        this.loading = false;
      },
      error: () => {
        this.accesses = [];
        this.page = 0;
        this.loading = false;
      },
    });
  }
}
